import assetProgressionData from "./assetProgression.js";
import balanceOverTimeData from "./balanceOverTime.js";
import cashflowProgressionData from "./cashflowProgression.js";
import debtCompositionData from "./debtComposition.js";
import debtServiceCoverageData from "./debtServiceCoverage.js";
import debtToAssetsData from "./debtToAssets.js";
import debtToCashflowsData from "./debtToCashflows.js";
import disbursementsAndRepaymentsData from "./disbursementsAndRepayments.js";
import liquidityData from "./liquidity.js";
import financialData from "./financialData.js";

export const chartData = {
    assetProgression: assetProgressionData,
    balanceOverTime: balanceOverTimeData,
    cashflowProgression: cashflowProgressionData,
    debtComposition: debtCompositionData,
    debtServiceCoverage: debtServiceCoverageData,
    debtToAssets: debtToAssetsData,
    debtToCashflows: debtToCashflowsData,
    disbursementsAndRepayments: disbursementsAndRepaymentsData,
    liquidity: liquidityData,
    financial: financialData,
};

export default chartData;
